var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.43 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,9.78a1.5,1.5,0,0,1-.35-3L29.58,0A1.5,1.5,0,0,1,30.28,3L1.85,9.74A1.45,1.45,0,0,1,1.5,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,28a1.5,1.5,0,0,1-.35-3l28.17-6.72a1.5,1.5,0,0,1,1.81,1.11,1.52,1.52,0,0,1-1.11,1.81L2.11,28A1.48,1.48,0,0,1,1.76,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,18.92a1.5,1.5,0,0,1-.35-3L29.58,9.18a1.5,1.5,0,0,1,.7,2.92L1.85,18.88A1.45,1.45,0,0,1,1.5,18.92Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuB);
export default __webpack_public_path__ + "static/media/menu-b.2194eeeb8b8234f7fc0c915a3ec2b239.svg";
export { ForwardRef as ReactComponent };